/**
 * DSS Stock Manager
 * 
 * Ersetzt Merchbees Push Down & Hide.
 * Regeln:
 * - NUR aktiv bei Bestseller-Sortierung (sort_by=best-selling oder default)
 * - Neue Produkte (≤ X Tage) → oben, nach Bestseller-Reihenfolge
 * - Tags "ignore"/"print" → exempt
 * - OOS → nach unten (Push Down) oder entfernen (Hide)
 * 
 * Bei manueller Sortierung: keine Regeln.
 */
(function () {
  'use strict';

  const SELECTOR_GRID = '#main-collection-product-grid';
  const SELECTOR_ITEM = '[data-js-product-item]';
  const SELECTOR_COUNT = '#CollectionProductCount';
  const SELECTOR_SORT = 'select[name="sort_by"]';

  function isBestSellingSort() {
    const params = new URLSearchParams(window.location.search);
    const sortParam = params.get('sort_by');
    if (sortParam) return sortParam === 'best-selling';

    const select = document.querySelector(SELECTOR_SORT);
    if (select && select.value) return select.value === 'best-selling';

    // Default sort = best-selling on most Shopify collections
    return !sortParam;
  }

  function initStockManager(grid) {
    if (!grid || grid.dataset.dssInit === 'true') return;
    grid.dataset.dssInit = 'true';

    const enableNew = grid.dataset.dssNewProducts === 'true';
    const newDays = parseInt(grid.dataset.dssNewDays, 10) || 21;
    const enablePush = grid.dataset.dssPushDown === 'true';
    const enableHide = grid.dataset.dssHide === 'true';
    const excludedTagsRaw = grid.dataset.dssExcludedTags || '';
    const showCount = grid.dataset.dssShowCount !== 'false';

    const excludedTags = excludedTagsRaw
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(Boolean);

    const bestSelling = isBestSellingSort();
    const hasRules = (enableNew || enablePush || enableHide) && bestSelling;

    if (!hasRules) {
      // Manuelle Sortierung oder keine Regeln → Hide trotzdem anwenden
      if (enableHide) applyHide(grid, showCount);
      return;
    }

    const items = Array.from(grid.querySelectorAll(SELECTOR_ITEM));
    if (!items.length) return;

    const now = Date.now();
    const msPerDay = 86400000;

    const isExcluded = (item) => {
      const tags = (item.dataset.tags || '').toLowerCase().split(',');
      return excludedTags.some(ex => tags.includes(ex));
    };

    const isNew = (item) => {
      if (!enableNew) return false;
      const pub = item.dataset.publishedAt;
      if (!pub) return false;
      const age = (now - new Date(pub).getTime()) / msPerDay;
      return age <= newDays;
    };

    const isOOS = (item) => item.dataset.available === 'false';

    // Kategorisieren mit Original-Position
    const excluded = [];
    const newProducts = [];
    const inStock = [];
    const oos = [];

    items.forEach((item, i) => {
      if (isExcluded(item)) {
        excluded.push({ el: item, pos: i });
      } else if (isOOS(item)) {
        oos.push({ el: item, pos: i });
      } else if (isNew(item)) {
        newProducts.push({ el: item, pos: i });
      } else {
        inStock.push({ el: item, pos: i });
      }
    });

    // Reihenfolge: exempt → neue → lagernd → OOS
    const sorted = [...excluded, ...newProducts, ...inStock, ...oos];
    const reordered = sorted.map(s => s.el);
    const unchanged = reordered.every((el, i) => el === items[i]);

    if (unchanged) return;

    // DOM-Update
    const fragment = document.createDocumentFragment();
    reordered.forEach(el => fragment.appendChild(el));
    grid.appendChild(fragment);

    // Produktanzahl anpassen
    if (showCount && (enableHide || enablePush)) {
      const visibleCount = grid.querySelectorAll(SELECTOR_ITEM).length;
      updateCount(grid, visibleCount);
    }
  }

  function applyHide(grid, showCount) {
    const items = Array.from(grid.querySelectorAll(SELECTOR_ITEM));
    let removed = 0;

    items.forEach(item => {
      if (item.dataset.available === 'false') {
        item.remove();
        removed++;
      }
    });

    if (showCount && removed) {
      const visibleCount = grid.querySelectorAll(SELECTOR_ITEM).length;
      updateCount(grid, visibleCount);
    }
  }

  function updateCount(grid, visibleCount) {
    const countEl = grid.closest('[data-js-inert]')?.querySelector(SELECTOR_COUNT)
      || document.querySelector(SELECTOR_COUNT);
    if (!countEl) return;

    const text = countEl.textContent.trim();
    const match = text.match(/\d+/);
    if (match) {
      countEl.textContent = text.replace(match[0], String(visibleCount));
    }
  }

  function scan() {
    document.querySelectorAll(SELECTOR_GRID).forEach(initStockManager);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
